import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=6bc3b844"
import script from "./MultiInput.vue?vue&type=script&lang=js"
export * from "./MultiInput.vue?vue&type=script&lang=js"
import style0 from "./MultiInput.vue?vue&type=style&index=0&id=6bc3b844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports